import { useCallback } from "react";
import { useBuilderStore } from "@circle-react-shared/BuilderUI/Hooks/useBuilderStore";
import { generateGoogleFontsLinkTags } from "./googleFontsUtils";

/**
 * Custom hook for managing Google Fonts in Builder UI frames
 * @returns Object containing Google Fonts data and link generation function
 */
export const useGoogleFonts = () => {
  const googleFonts = useBuilderStore(state => state.googleFonts);

  const getGoogleFontsLinkTags = useCallback(
    () => generateGoogleFontsLinkTags(googleFonts),
    [googleFonts],
  );

  return {
    googleFonts,
    getGoogleFontsLinkTags,
  };
};
